<template>
  <div v-if="getDiscount.length > 0" class="popup-discount" :class="{ 'popup-discount-small': small }">
    <el-popover placement="bottom" trigger="click">
      <div v-if="!small" slot="reference">
        <div class="popup-discount-button">Réductions
        </div>
      </div>
      <div v-else slot="reference">
        <div class="calendar-day-discount-button">%</div>
      </div>
      <div class="popup-discount-content">
        <div class="popup-discount-content-row" v-for="discount in getDiscount">
          <h2 class="popup-discount-content-row-hours">{{ discount.hourStart }} - {{ discount.hourEnd }}</h2>
          <div class="popup-discount-content-row-discount">
            <h2>-{{ discount.discount }}%</h2>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import isBetween from 'dayjs/plugin/isBetween'
import { mapGetters } from 'vuex'

dayjs.extend(isBetween)
dayjs.locale('fr')

export default {
  name: 'PopupDiscountDisplay',
  props: {
    date: {
      type: Object,
      required: true
    },
    service: {
      type: String
    },
    small: {
      type: Boolean
    }
  },
  data() {
    return {
      popover: false
    }
  },
  methods: {
    formatDayWithLowercase(text) {
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    screenDiscountSelected: function () {
      this.showHideScreenDiscount()
    },
    parseTime(timeStr) {
      const [hours, minutes] = timeStr.split(':').map(Number)
      return hours * 60 + minutes
    },
    intervalsOverlap(start1, end1, start2, end2) {
      return start1 < end2 && start2 < end1
    }
  },
  computed: {
    ...mapGetters({
      getAllDiscount: 'discount/getAllDiscount',
      getAllServices: 'newServices/getAllServices'
    }),
    getWeekday() {
      return this.formatDayWithLowercase(dayjs(this.date.date).format('dddd'))
    },
    getService(weekday) {
      return this.getAllServices[this.service][this.getWeekday]
    },
    getDiscount() {
      const day = dayjs(this.date.date)
      if (!this.getAllDiscount || !this.getAllDiscount.length > 0) return []
      const discounts = this.getAllDiscount.filter(discount => {
        const startDate = dayjs(discount.dates[0]).startOf('day')
        const endDate = dayjs(discount.dates[1]).startOf('day')

        const isThisDate = day.isBetween(startDate, endDate, 'day', '[]')
        if (!isThisDate) return false
        const discountsOfDay = discount[this.getWeekday]
        if (discountsOfDay.length > 0) return true
      }).map(discount => {
        const discountsOfDay = discount[this.getWeekday]
        return discountsOfDay
      }).flat()

      if (this.service) {
        const serviceStart = this.parseTime(this.getService.opening)
        const serviceEnd = this.parseTime(this.getService.closing)

        return discounts.filter(discount => {
          const discountStart = this.parseTime(discount.hourStart)
          const discountEnd = this.parseTime(discount.hourEnd)

          return this.intervalsOverlap(serviceStart, serviceEnd, discountStart, discountEnd)
        })
      } else {
        return discounts
      }
    }
  }
}
</script>

<style lang="scss">
.popup-discount {
  display: inline-block;

  &-small {
    display: block;
  }
}

.popup-discount-content {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &-row {
    display: flex;
    justify-content: space-between;
    gap: 32px;
    align-items: center;

    &-hours {
      margin: 0;
    }

    &-discount {
      background-color: var(--color_red);
      color: white;
      padding: 5px;
      border-radius: 5px;

      h2 {
        margin: 0;
      }
    }
  }
}
</style>